import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useGlobalScanner, getScanPageHandler } from "@/hooks/useGlobalScanner";

// Fiziksel barkod okuyucu global olarak dinlenir.
// - Bir sayfa handler kaydettiyse (ör. Hızlı Satış → sepete ekle) ona verilir.
// - Aksi halde okutulan ürün Stok Kataloğu'nda düzenleme ekranında açılır.
export default function GlobalScanner() {
  const navigate = useNavigate();
  useGlobalScanner((code) => {
    const h = getScanPageHandler();
    if (h) { h(code); return; }
    toast.success(`Barkod okundu: ${code} — ürün açılıyor`);
    navigate(`/stok?scan=${encodeURIComponent(code)}`);
  });
  return null;
}
